import { selectFromUserInviteDto } from '../../models';

export default selectFromUserInviteDto()
  .id
  .uuid
  .organizationId
  .email
  .fullname
  .role(r => r.name)
  .inviteStatusId
  .expiresOn
  .toString();
